import useSettingsService from 'components/hooks/useSettingsService';
import React, { useState } from 'react';
import { useCreateConfigurationFromFilters } from './useCreateConfigurationFromFilters';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { PM_METRICS_DEFINITION } from './usePMConfig';
import Text from 'components/base/Text';

export const useSavePMConfig = ({
  selectedFilters,
  incidentStrategy,
  incidentConfig,
  shouldAddIncidentToConfig,
  teamId,
  PMMetric,
  toggleSnackBar
}) => {
  const [isSaveEnabled, setIsSaveEnabled] = useState(true);

  const settingConfig = PM_METRICS_DEFINITION[PMMetric].settings_value;
  const pageTab = PM_METRICS_DEFINITION[PMMetric].page_tab;

  const { updateSetting } = useSettingsService();

  const { createConfigurationFromSelectedFilters } =
    useCreateConfigurationFromFilters({
      selectedFilters,
      incidentStrategy,
      incidentConfig,
      shouldAddIncidentToConfig
    });

  const toast = (message, isSuccess) => {
    toggleSnackBar({
      message: (
        <Text size='large' color='white'>
          {message}
        </Text>
      ),
      variant: isSuccess ? 'success' : 'error'
    });
  };

  const saveSettings = async () => {
    const onSuccess = () =>
      toast(
        `${pageTab} Settings updates successfully. It might take a few minutes to see the updated data`,
        true
      );
    const onFailure = () =>
      toast(`We were unable to update your ${pageTab} settings`, false);

    try {
      const newConfig = createConfigurationFromSelectedFilters();
      const settingLevel = teamId ? 'team' : 'organization';
      const entityId = teamId;
      await updateSetting(settingConfig, newConfig, settingLevel, entityId);
      onSuccess();
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        click_type: TRACKING.CLICK.SAVE,
        page: TRACKING.PAGES.SETTINGS,
        page_tab: pageTab
      });
    } catch (e) {
      onFailure();
    }
  };

  return { saveSettings, isSaveEnabled, setIsSaveEnabled };
};
